import React, { Component, Fragment } from 'react'
import PT from 'prop-types'
import { withRouter } from 'react-router-dom'

class AboveForm extends Component {
  render() {
    const is89 = this.props.location.pathname.startsWith('/89')

    if (is89) {
      return (
        <Fragment>
          <h2>
            Čo ste robili v<br />
            novembri 1989?<br />
            Pridajte príbeh…
          </h2>
          <p>Boli ste na námestí? V škole v prírode? Sledovali ste dianie doma cez televízor? Dôležité pre pochopenie udalostí sú veľké aj malé ľudské príbehy. Budeme vďačné za váš príbeh.</p>
        </Fragment>
      )
    }

    return (
      <Fragment>
        <h2>
          Čo robili vaši 21.&nbsp;augusta&nbsp;1968?
          <br />
          Pridaj príbeh…
        </h2>
      </Fragment>
    )
  }
}

AboveForm.propTypes = {
  location: PT.shape({
    pathname: PT.string.isRequired,
  }).isRequired,
}

export default withRouter(AboveForm)



// WEBPACK FOOTER //
// ./src/components/AboveForm.js